"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.foodOpsRequest = exports.staffRequest = exports.requestPatient = exports.request = void 0;
exports.authenticateUser = authenticateUser;
var fs_1 = require("fs");
var graphql_request_1 = require("graphql-request");
var isobject_1 = __importDefault(require("isobject"));
var amazon_cognito_identity_js_1 = require("amazon-cognito-identity-js");
var aws_config_admin_1 = __importDefault(require("@fdha/aws-config-admin"));
function authenticateUser(username, password, userPoolId, clientId) {
    return __awaiter(this, void 0, void 0, function () {
        var authenticationDetails, userPool, cognitoUser;
        return __generator(this, function (_a) {
            authenticationDetails = new amazon_cognito_identity_js_1.AuthenticationDetails({
                Username: username,
                Password: password,
            });
            userPool = new amazon_cognito_identity_js_1.CognitoUserPool({
                UserPoolId: userPoolId,
                ClientId: clientId,
            });
            cognitoUser = new amazon_cognito_identity_js_1.CognitoUser({
                Username: username,
                Pool: userPool,
            });
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    cognitoUser.authenticateUser(authenticationDetails, {
                        onSuccess: function (result) {
                            var idToken = result.getIdToken().getJwtToken();
                            resolve(idToken);
                        },
                        onFailure: function (err) {
                            reject(err);
                        },
                    });
                })];
        });
    });
}
var parseValueString = function (value) {
    try {
        var obj = JSON.parse(value);
        if ((0, isobject_1.default)(obj)) {
            return obj;
        }
    }
    catch (_a) {
        // it's cool - value didn't have json in the first place
    }
    return value;
};
var parseValueArray = function (values) {
    return values.map(function (value) { return parseValueString(value); });
};
var parseVariableJson = function (key, value) {
    var _a;
    if (key === 'picture' && typeof value === 'string') {
        var _b = (_a = value.match(/^\$file\("(.*)"\)$/)) !== null && _a !== void 0 ? _a : [], fileName = _b[1];
        if (fileName == null) {
            return [key, value];
        }
        var file = (0, fs_1.createReadStream)(fileName);
        return [key, file];
    }
    if (typeof value === 'string') {
        return [key, parseValueString(value)];
    }
    if (Array.isArray(value)) {
        return [key, parseValueArray(value)];
    }
    return [key, value];
};
var parseVariablesJson = function (variables) {
    if (!variables) {
        return;
    }
    var entries = Object.entries(variables).map(function (_a) {
        var key = _a[0], value = _a[1];
        return parseVariableJson(key, value);
    });
    return Object.fromEntries(entries);
};
var request = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var idToken, parsedVariables, client;
    var email = _b.email, password = _b.password, query = _b.query, variables = _b.variables;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, authenticateUser(email, password, aws_config_admin_1.default.cognito.adminUserPoolId, aws_config_admin_1.default.cognito.adminUserPoolClientId)];
            case 1:
                idToken = _c.sent();
                if (idToken == null) {
                    throw new Error('Not logged in!');
                }
                parsedVariables = parseVariablesJson(variables);
                client = new graphql_request_1.GraphQLClient(aws_config_admin_1.default.api.adminApiBaseUrl, {
                    headers: {
                        Authorization: "Bearer ".concat(idToken),
                        'x-api-key': aws_config_admin_1.default.api.apiKey,
                    },
                });
                return [2 /*return*/, client
                        .request(query, parsedVariables)
                        .then(function (data) {
                        console.log(data);
                        return data;
                    })
                        .catch(function (error) { return console.log(error); })];
        }
    });
}); };
exports.request = request;
var requestPatient = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var idToken, parsedVariables, client;
    var email = _b.email, password = _b.password, query = _b.query, variables = _b.variables;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, authenticateUser(email, password, aws_config_admin_1.default.cognito.patientUserPoolId, aws_config_admin_1.default.cognito.patientUserPoolClientId)];
            case 1:
                idToken = _c.sent();
                if (idToken == null) {
                    throw new Error('Not logged in!');
                }
                parsedVariables = parseVariablesJson(variables);
                client = new graphql_request_1.GraphQLClient(aws_config_admin_1.default.api.patientApiBaseUrl, {
                    headers: {
                        Authorization: "Bearer ".concat(idToken),
                        'x-api-key': aws_config_admin_1.default.api.apiKey,
                    },
                });
                return [2 /*return*/, client
                        .request(query, parsedVariables)
                        .then(function (data) { return console.log(data); })
                        .catch(function (error) { return console.log(error); })];
        }
    });
}); };
exports.requestPatient = requestPatient;
var staffRequest = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var idToken, parsedVariables, client;
    var email = _b.email, password = _b.password, query = _b.query, variables = _b.variables;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, authenticateUser(email, password, aws_config_admin_1.default.cognito.siteStaffUserPoolId, aws_config_admin_1.default.cognito.siteStaffUserPoolClientId)];
            case 1:
                idToken = _c.sent();
                if (idToken == null) {
                    throw new Error('Not logged in!');
                }
                parsedVariables = parseVariablesJson(variables);
                client = new graphql_request_1.GraphQLClient(aws_config_admin_1.default.api.siteStaffApiBaseUrl, {
                    headers: {
                        Authorization: "Bearer ".concat(idToken),
                        'x-api-key': aws_config_admin_1.default.api.apiKey,
                    },
                });
                return [2 /*return*/, client
                        .request(query, parsedVariables)
                        .then(function (data) {
                        console.log(data);
                        return data;
                    })
                        .catch(function (error) {
                        console.log(error);
                        return error;
                    })];
        }
    });
}); };
exports.staffRequest = staffRequest;
var foodOpsRequest = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var idToken, parsedVariables, client;
    var email = _b.email, password = _b.password, query = _b.query, variables = _b.variables;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, authenticateUser(email, password, aws_config_admin_1.default.cognito.foodOpsUserPoolId, aws_config_admin_1.default.cognito.foodOpsUserPoolClientId)];
            case 1:
                idToken = _c.sent();
                if (idToken == null) {
                    throw new Error('Not logged in!');
                }
                parsedVariables = parseVariablesJson(variables);
                client = new graphql_request_1.GraphQLClient(aws_config_admin_1.default.api.foodOpsApiBaseUrl, {
                    headers: {
                        Authorization: "Bearer ".concat(idToken),
                        'x-api-key': aws_config_admin_1.default.api.apiKey,
                    },
                });
                return [2 /*return*/, client
                        .request(query, parsedVariables)
                        .then(function (data) {
                        console.log(data);
                        return data;
                    })
                        .catch(function (error) { return console.log(error); })];
        }
    });
}); };
exports.foodOpsRequest = foodOpsRequest;
